import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-1RJ6TEC2W1'; // Reemplazalo por el tuyo

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (referrer: string) => {
  ReactGA.event({
    category: 'Origen',
    action: 'portal_origen',
    label: referrer,
  });
};
